export default __webpack_public_path__ + "assets/front/scss/editorial.feec307601b668ffc326acbea69635ca.css";